import { Form, Select } from 'antd';
import React from 'react';
import classes from './style/DepartmentsHeader.module.css';
import { ICategories } from '../../../types/TestType';

const DepartmentsHeader = ({
  categories,
  handleChange,
}: {
  categories: ICategories[];
  handleChange: (value: number) => void;
}) => {
  const [form] = Form.useForm();
  return (
    <div className={classes.header}>
      <Form form={form} autoComplete="off" layout="vertical">
        <Form.Item
          style={{ width: 450 }}
          label="Фильтр по категориям"
          name="category_id"
          initialValue={1}
        >
          <Select onChange={handleChange} placeholder="Категория урока">
            <Select.Option value={1}>Все</Select.Option>
            {categories.map((item: ICategories) => {
              return (
                <Select.Option value={item?.id} key={item?.id}>
                  {item.title}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
    </div>
  );
};

export default DepartmentsHeader;
